var wearTab = {

	triggerEl: $('.wear-tab'),
	targetEl: $('.wear-carousel'),
	slideEl: $('.wear-carousel-item'),

	wearWrapper: $('.wear-carousel'),

	checkIfAplicable: function() {
		wearTab.wearWrapper.each(function(){
			var _this = $(this);
			var slides = _this.find(wearTab.slideEl);
			var slides_number = slides.length - 1;
			var slides_width = 240;

			var wrapper_width = _this.closest('.component-wear').width();
			var slides_width_total = slides_number * slides_width;

			if (slides_width_total > wrapper_width) {
				if (!_this.hasClass('flickity-enabled')) {
					wearTab.slider(_this);
				}
			} else {
				if (_this.hasClass('flickity-enabled')) {
					_this.flickity('destroy');
				}
				_this.addClass('no-carousel').removeClass('loading');
				if (_this.hasClass('first')) {
					_this.addClass('current');
				}
			}
		});
	},

	nav: function() {
		wearTab.triggerEl.click(function(){
			var _this = $(this);

			if (_this.hasClass('current')) {
				return;
			} else {
				var stylist = _this.attr('data-wear-trigger');

				wearTab.triggerEl.removeClass('current');
				wearTab.targetEl.removeClass('current');

				$(this).addClass('current');
				$('[data-wear-target="' + stylist + '"]').addClass('current');

				if ($('[data-wear-target="' + stylist + '"]').hasClass('flickity-enabled')) {
					setTimeout(function() {
						$('[data-wear-target="' + stylist + '"]').flickity('resize');
					},50);
				}
			}
		});
	},

	slider: function(targetEl) {
		var _this = targetEl;

		_this.flickity({
			groupCells: true,
			freeScroll: true,
			wrapAround: true,
			prevNextButtons: false,
			pageDots: false,
			dragThreshold: 10,
			rightToLeft: window.rtl
		});
		_this.removeClass('loading');
		if (_this.hasClass('first')) {
			_this.addClass('current');
		}
		if (_this.hasClass('no-carousel')) {
			_this.removeClass('no-carousel');
		}
	},

	init: function() {
		if (wearTab.triggerEl.length) {
			wearTab.checkIfAplicable();
			wearTab.nav();
		}
	}
};